import GenericAction from '@/components/actions/GenericAction.tsx'
import { Pin } from 'lucide-react'
import AActionContentGenericLayout from '@/components/actions/components/AActionContentGenericLayout.jsx'
import AActionContentTerminal from '@/components/actions/components/AActionContentTerminal'

export default function SetFilePinnedStateAction({
  action,
  isLast = false,
  isInteractive = false,
}) {
  const args = action?.args ?? {}
  const filePath = args.path
  let detailsContent = `## PATH:\n${filePath}\n\n## COMMENT:\n${args.comment}\n\n`

  return (
    <GenericAction
      action={action}
      detailsContent={detailsContent}
      actionIcon={Pin}
      isLast={isLast}
      isInteractive={isInteractive}
      title={action?.args?.comment ?? 'Set file pinned state'}
    >
      <AActionContentGenericLayout>
        <AActionContentTerminal
          content={filePath}
          terminalOutputs={null}
          errored={action?.outputs?.error}
        />
      </AActionContentGenericLayout>
    </GenericAction>
  )
}
